export const registeredAddressText =
  "3rd  Floor, 26 Community Centre, Mayapuri Phase 1, New Delhi - 110064";
export const registeredAddressHtml = (
  <p>
    3rd Floor, 26 Community Centre, <br />
    Mayapuri Phase 1, <br />
    New Delhi - 110064
  </p>
);
export const addressHtml = (
  <p>
    HD-028 WeWork DLF forum, <br />
    Cybercity Phase III, <br />
    Gurugram - 122002
  </p>
);
export const addressText =
  "HD-028 WeWork DLF forum, Cyber City Phase III, Gurugram - 122002";
export const officeaddressHtml = (
  <p>
    HD-028 WeWork DLF forum, <br />
    Cyber City Phase III, <br />
    Gurugram - 122002
  </p>
);
export const phone = "011 45511599";
export const telLink = "tel:01145511599";
export const email = "aquariusteam@aquariusconsultants.in";
export const mailto = "mailto:aquariusteam@aquariusconsultants.in";
